import { SET_CALL_METHOD } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageSetCallMethod(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: SET_CALL_METHOD,
      data
    });
  }
}